const Divider = {
  baseStyle: {
    color: "secondary.500",
  },
};

export default Divider;
